import React from 'react'

import { Hero, VideoPlayButton } from '../../Common'

export const VideoBlock = () => {
    return (
        <Hero>
            <VideoPlayButton />
        </Hero>
    )
}
